import styles from '@shared/styles/components/ProgressBar.module.css'

interface ProgressBarProps {
    /** 0..1 */
    progress: number
    ariaLabel?: string
    className?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, ariaLabel, className }) => {
    const clamped = Math.min(1, Math.max(0, progress))
    return (
        <div
            className={['DSProgressBar', styles.track, className].filter(Boolean).join(' ')}
            role='progressbar'
            aria-label={ariaLabel}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(clamped * 100)}
        >
            <div className={styles.fill} style={{ width: `${clamped * 100}%` }} />
        </div>
    )
}
